import Navbar from "./components/Navbar";
import Form from "./components/Form";

const About = () => {
  return (
      <div>
        <Navbar />
        <Form />
    </div>
  )
}

export default About
